<template>
  <div v-if="loaded">
    <div class="hero" v-if="hasBannerFlag">
      <img src="../assets/images/hero-img.png" alt="welcome our page">
      <div class="hero__content">
        <div class="hero__title-section">
          <div class="hero__title">
            <h1>
              <div class="hero__title--yellow">{{ $t('hero.title') }}</div>
              <div class="hero__title--white">{{ $t('hero.subtitle') }}</div>
            </h1>
          </div>
          <button class="hero__cta-button" v-if="!isLoggedIn" @click="checkIsLogged">{{ $t("signin") }}</button>
        </div>
        <div class="hero__content--bottom">
          <ul>
            <li>
              <div class="list-image">
                <img src="../assets/images/icons/home_icon_1.png" :alt="$t('hero.banner.title1')">
              </div>
              <h2 class="text-uppercase">{{ $t("hero.banner.title1") }}</h2>
            </li>
            <li>
              <div class="list-image">
                <img src="../assets/images/icons/home_icon_2.png" :alt="$t('hero.banner.title2')">
              </div>
              <h2 class="text-uppercase">{{ $t("hero.banner.title2") }}</h2>
            </li>
            <li>
              <div class="list-image">
                <img src="../assets/images/icons/home_icon_3.png" :alt="$t('hero.banner.title3')">
              </div>
              <h2 class="text-uppercase">{{ $t("hero.banner.title3") }}</h2>
            </li>
            <li>
              <div class="list-image">
                <img src="../assets/images/icons/home_icon_4.png" :alt="$t('hero.banner.title4')">
              </div>
              <h2 class="text-uppercase">{{ $t("hero.banner.title4") }}</h2>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="products" v-for="category in allCategories" :key="category.order">
      <section class="section--products">
        <BaseCarousel
          :products="category.products"
          :title="category.fullname"
          :categoryId="category.name"
          :layout="category.design"
        />
      </section>
    </div>

    <section class="section--our-categories">
      <div class="our-categories__head">
        <div class="our-categories__head-inner">
          <h3><span class="our-categories__dash">—</span> {{ $t("home.ourcategories.title") }}</h3>
        </div>
      </div>
      <div class="our-categories__body">
        <div class="our-categories__grid">
          <router-link
            v-for="category in visibleOurCategories"
            :key="category.id"
            :to="{
              name: 'ProductCategory',
              params: {
                type: ($route.params.id || '1'),
                title: category.item,
                id: category.id
              }
            }"
            class="category-card"
          >
            <div class="category-card__icon">
              <img :src="category.img" :alt="category.item" />
            </div>
            <div class="category-card__name">{{ category.item }}</div>
          </router-link>
        </div>
      </div>
    </section>

    <cookie-law theme="portal" :buttonText="$t('cookie.btn')">
      <template #message>
        <div :class="[currentLanguage == 'AR' ? 'rtlText': '']">
          {{ $t("cookie.message") }}
          <router-link to="cookies-policy" :class="[currentLanguage == 'AR' ? 'rtlText': '']">
            {{ $t("cookie.link") }}
          </router-link>
        </div>
      </template>
    </cookie-law>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import { helpers } from '../helper/portal_config'
import EventBus from '../helper/event_bus'
import CookieLaw from '../components/CookieLaw.vue'
import BaseCarousel from '../components/BaseCarousel'

const apiPrTypeMethod = 'getProductListByType'

export default {
  name: 'Home',
  title: helpers.portal_name,
  components: {
    BaseCarousel,
    CookieLaw
  },
  data() {
    return {
      categories: [],
      allCategories: [],
      hasBannerFlag: null,
      currentLanguage: '',
      currentCountry: '',
      loaded: false
    }
  },
  computed: {
    ...mapGetters({
      accessCode: 'globals/accessCode',
      isLoggedIn: 'globals/isLoggedIn'
    }),
    visibleOurCategories() {
      const categoriesFiltered = (this.categories || []).filter(c => c && c.order != null)
      categoriesFiltered.forEach(categ => {
        try {
          categ.img = require(`@/assets/images/icons/${categ.icon_identifier}.png`)
        } catch (e) {
          console.warn(`Icon not found for category: ${categ.item}`)
          categ.img = require('@/assets/images/icons/logic.png')
        }
      })
      return categoriesFiltered
    }
  },
  methods: {
    checkIsLogged() {
      // if you are not login than showed modal
      if (!this.isLoggedIn) {
        EventBus.$emit('SHOW_SIGNIN_MODAL');
      }
    },
    setProducts(types) {
      const keys = Object.keys(types)
      keys.forEach((element) => {
        types[element].fullname = element
        this.allCategories.push(types[element])
      })
      const categoriesFiltered = this.allCategories.filter(item => item.homepage > 0)
      this.sortProducts(categoriesFiltered)
    },
    sortProducts(filteredProducts) {
      filteredProducts.sort((a, b) => a.homepage - b.homepage)
      filteredProducts = this.slicesProducts(filteredProducts)
      this.allCategories = filteredProducts
    },
    slicesProducts(products) {
      return products.map(item => {
        item.products = item.products.slice(0, item.max_products)
        return item
      })
    },
    sortCategories(categoriesLocal) {
      categoriesLocal.sort((a, b) => a.order - b.order)
      this.categories = categoriesLocal
    },
    hasBanner() {
      const banner = document.querySelector('.page-header__menu li.is-active a')
      const type = banner.getAttribute('href').substr(banner.getAttribute('href').length - 1, banner.getAttribute('href').length)
      return helpers.menu.some(item => item.type == type && item.isActive == true && item.banner == 1)
    },
    setCurrentCountry() {
      const { host } = window.location
      this.currentCountry = host.split('.')[0].slice(0, 2).toUpperCase()
    },
    setCurrentLanguage() {
      const { host } = window.location
      const country = host.split('.')[0].slice(0, 2).toUpperCase()
      const map = helpers.countryDefaultLanguage || {}
      this.currentLanguage = (map.hasOwnProperty(country) ? map[country] : country).toUpperCase()
    },
    async fetchCategories() {
      this.loaded = false
      const baseUrl = `${helpers.API_BASE_URL}/store/${apiPrTypeMethod}`
      const params = new URLSearchParams({
        portal_name: helpers.portal_name,
        country: this.currentCountry,
        language: this.currentLanguage,
        product_type: this.$route.params.id || helpers.portal_type
      })

      if (this.isLoggedIn) {
        params.append('access_code', this.accessCode)
      }

      await axios.get(`${baseUrl}?${params}`).then(response => {
        if (response.data.treatment === 1) {
          const { categories } = response.data
          this.setProducts(categories)

          const categoriesLocal = Object.keys(categories).map(element => ({
            id: categories[element].name,
            item: element,
            order: categories[element].order,
            icon_identifier: categories[element].icon_identifier
          }))

          this.sortCategories(categoriesLocal)
          this.loaded = true
        }
      })
    }
  },
  watch: {
    $route() {
      this.allCategories = []
      this.categories = []
      this.fetchCategories()
    }
  },
  created() {
    this.helpers = helpers
    this.setCurrentLanguage()
    this.setCurrentCountry()
    this.fetchCategories()
  },
  mounted() {
    this.hasBannerFlag = this.hasBanner()
  }
}
</script>

<style src="../assets/styles/portal.css"></style>
